
import { http } from '../../http';
import {filter} from "lodash/collection";
import sortBy from "lodash/sortBy";

export default {
    state: {
        sendableItems: [],
        loading: false
    },


    mutations: {
        setIsLoading(state, isLoading = true) {
            state.loading = isLoading;
        },

        setSendableItems(state, data) {
            state.sendableItems = data;
        },

        deleteSendableItem(state, sendable_item){
            let index = state.sendableItems.findIndex(sendableItem => sendableItem.id == sendable_item.id);
            state.sendableItems.splice(index, 1);
        },

        updateSendableItem(state, sendable_item_to_update){
            let index = state.sendableItems.findIndex(sendableItem => sendableItem.id == sendable_item_to_update.id);
            state.sendableItems[index] = sendable_item_to_update;
        },

        addSendableItem(state, sendable_item){
            state.sendableItems.push(sendable_item);
        }
    },

    getters: {
        getSendableItems: (state, getters) => {
            return state.sendableItems;
        },

        getSendableItemsSentBefore: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.should_be_sent_before_resource;
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        getSendableItemsSentOnCreate: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.sending_schedule === 'on_creation';
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        getSendableItemsSentOnUpdate: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.sending_schedule === 'on_update';
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        getSendableItemsSentOnDelete: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.sending_schedule === 'on_delete';
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        getSendableItemsSentOnStart: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.sending_schedule === 'on_start';
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        getSendableItemsSentAfter: (state, getters) => {
            var sendable_items_filtered = filter(state.sendableItems, (sendable_item) => {
                return sendable_item.sendable.should_be_sent_after_resource;
            });

            return sortBy( sendable_items_filtered, (sendable_item) => {
                return sendable_item.sendable.sort_order;
            });
        },

        isLoading : (state, getters) => {
            return state.loading;
        }
    },

    actions: {

        loadSendableItems (state, query_params) {

            if (state.loading) {
                return;
            }

            state.commit('setIsLoading', true);

            http.get('/app/sendable-items', { params: query_params })
                .then(({ data }) => {
                    state.commit('setSendableItems', data);
                    state.commit('setIsLoading', false);
                });
        },

        deleteSendableItem ({commit}, sendable_item) {

            return new Promise((resolve, reject) => {

                http.delete('/app/sendable-items/' + sendable_item.id)
                    .then(response => {
                        commit('deleteSendableItem', sendable_item);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },

        cancelSendableItem ({commit}, sendable_item) {

            return new Promise((resolve, reject) => {

                http.post('/app/sendable-items/' + sendable_item.id + '/undo-send')
                    .then(response => {
                        commit('updateSendableItem', response.data);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },

        redoSendingOfSendableItem ({commit}, sendable_item) {

            return new Promise((resolve, reject) => {

                http.post('/app/sendable-items/' + sendable_item.id + '/redo-send')
                    .then(response => {
                        commit('updateSendableItem', response.data);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },

        generateAndSendSendableItem ({commit}, sendable_item) {

            return new Promise((resolve, reject) => {

                http.post('/app/sendable-items/generate-and-send', sendable_item )
                    .then(response => {
                        commit('deleteSendableItem', sendable_item);
                        commit('addSendableItem', response.data.sendable_item);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },

        sendSendableItem ({commit}, sendable_item) {

            return new Promise((resolve, reject) => {

                http.post('/app/sendable-items/' + sendable_item.id + "/send")
                    .then(response => {
                        commit('updateSendableItem', response.data.sendable_item);
                        resolve(response);
                    }, error => {
                        reject(error);
                    });

            })
        },
    }
};
